import {useMutation} from '@apollo/client/react';
import {extractGqlData} from '@coolcolduk/ui-apollo-client';
import {SeedQuestion, SeedQuestionSource} from '@cp/model';
import {CREATE_SEED_QUESTION} from '../sharedQueries';

export function useCreateSeedQuestion() {
  const [createSeedQuestionMutation, {loading, error}] = useMutation<
    {createSeedQuestion: SeedQuestion},
    {
      moduleId: string;
      questionText: string;
      topic: string;
      options: string[];
      answer: string;
      source: SeedQuestionSource;
    }
  >(CREATE_SEED_QUESTION);

  const createSeedQuestion = async (
    moduleId: string,
    questionText: string,
    topic: string,
    options: string[],
    answer: string,
    source: SeedQuestionSource,
  ) => {
    const result = await createSeedQuestionMutation({
      variables: {
        moduleId,
        questionText,
        topic,
        options,
        answer,
        source,
      },
    });

    return extractGqlData(result).createSeedQuestion;
  };

  return {
    createSeedQuestion,
    loading,
    error,
  };
}
